import React, { useEffect, useState } from 'react';
import NotFound from '../NotFound/index.jsx';
import Faq from './index.jsx';
import { getFaqs } from '../../services/Api/CMS/CMSService';

function FaqLayout(props) {
  const initialRepos = (() => {
    if (
      typeof window !== 'undefined' &&
      typeof window.__INITIAL_DATA__ !== 'undefined'
    ) {
      return window.__INITIAL_DATA__;
    }
    return props.staticContext && props.staticContext.data;
  })();

  const [repos, setRepos] = useState(initialRepos);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      if (!repos) {
        const res = await getFaqs(props.i18n.language);
        if (!cancelled) setRepos(res);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, []); // run once on mount

  return repos && repos.status >= 400 ? (
    <NotFound />
  ) : (
    <main>
      <Faq faqs={repos && repos.faqs} />
    </main>
  );
}

export default FaqLayout;
